import axios from 'axios';
import {
  COMMENTS_ENDPOINT,
  SERVER_HOST,
} from '../../../../constants/endpoints';
import { departments } from '../../../../constants/volunteers';

const sendCommentToDB = async (commentObjectID, email, comment) => {
  try {
    return axios({
      method: 'POST',
      url: SERVER_HOST + COMMENTS_ENDPOINT(commentObjectID),
      data: {
        head: departments.find((item) => item.email === email)?.head,
        departmentID: departments.find((item) => item.email === email)?.id,
        comment: comment,
      },
    });
  } catch (error) {
    return error;
  }
};

export default sendCommentToDB;
